import React from "react";

// utils
import { addZero, moneyFormatter } from "bodycodi/cmap/app/js/common";

const formatDate = (startDate: any, endDate: any) => {
  const date = startDate.split("T")[0];
  let startTime = new Date(startDate).toLocaleTimeString("en-US", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
  let endTime = new Date(endDate).toLocaleTimeString("en-US", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });

  return date + " | " + startTime + "~" + endTime;
};

const SalesCard = ({ detail }: any) => {
  const SALES_CLASSIFICATION: any = {
    ORDER: <span className="badge orange">주문</span>,
    UPGRADE: <span className="badge orange">업그레이드</span>,
    MERGE: <span className="badge orange">결합</span>,
    CROSS: <span className="badge green">교체</span>,
    TRANSFER: <span className="badge purple">양도</span>,
    CANCEL_ORDER: <span className="badge red">주문 취소</span>,
    CANCEL_MERGE: <span className="badge red">결합 취소</span>,
    CANCEL_UPGRADE: <span className="badge red">업그레이드 취소</span>,
    CANCEL_CROSS: <span className="badge red">교체취소</span>,
    CANCEL_TRANSFER: <span className="badge purple">양도 취소</span>,
    REFUND: <span className="badge red">환불</span>,
    CANCEL_REFUND: <span className="badge red">환불 취소</span>,
    UPDATE_REFUND: <span className="badge green">환불 수정</span>,
    UPDATE_PAYMENT_INFO: <span className="badge green">결제정보 수정</span>,
    UPDATE_ORDER_INFO: <span className="badge green">주문정보 수정</span>,
    UPDATE_PAYMENT: <span className="badge green">결제 수정</span>,
    RECEIVABLE_PAYMENT: <span className="badge green">미수금 결제</span>,
  };

  return (
    <div className="card">
      <div className="top">
        <span>{detail?.orderDate}</span>
        {SALES_CLASSIFICATION[detail?.passModifyType]}
      </div>

      <div className="middle">
        <span>{detail?.orderName}</span>
        <span>{detail?.memberName}</span>
      </div>

      <div className="bottom">
        <span>결제금액</span>
        <span> {moneyFormatter(detail?.paymentAmount)} </span>
      </div>
    </div>
  );
};

const AppointmentCard = ({ detail }: any) => {
  const PASS_TYPE: any = {
    NEW: "신규",
    INUSE: "재결제",
  };

  const getScheduleState = () => {
    if (detail?.scheduleState === "A") {
      return detail?.voucherMinusYn === "Y" ? (
        <span className="badge orange">차감결석</span>
      ) : (
        <span className="badge orange">미차감결석</span>
      );
    }

    if (detail?.scheduleState === "E") {
      return detail?.nonWorkHourFlag ? (
        <span className="badge green">시간외 출석</span>
      ) : (
        <span className="badge green">출석</span>
      );
    }
  };

  return (
    <div className="card">
      <div className="top">
        <span>{formatDate(detail.startDate, detail.endDate)}</span>
        {getScheduleState()}
      </div>

      <div className="middle">
        <span>{detail?.orderName}</span>
        <span>{`${detail?.memberName} · ${PASS_TYPE[detail?.passType]}`}</span>
      </div>

      <div className="bottom">
        <span>수당 정산액</span>
        <span>{moneyFormatter(detail?.allowance)}</span>
      </div>
    </div>
  );
};

const GroupCard = ({ detail }: any) => {
  return (
    <div className="card">
      <div className="top">
        <span>{formatDate(detail.startDate, detail.endDate)}</span>
      </div>

      <div className="middle">
        <span>{detail?.scheduleName}</span>
        <span>{`참여회원 ${detail?.entranceMemberCount}명`}</span>
      </div>

      <div className="bottom">
        <span>수당 정산액</span>
        <span>{moneyFormatter(detail?.totalAllowance)}</span>
      </div>
    </div>
  );
};

export { SalesCard, AppointmentCard, GroupCard };
